/**
 * News configuration
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('shop', {
            url: '/' + urls.shop.fr, // TODO : when multilang, change this to something dynamic
            abstract: true,
            template: '<div ui-view></div>'
        })
        .state('shop.list', {
            url: '',
            controller: ['$scope', '$rootScope', 'drupal', 'headermanager', '$state', '$filter', '$window', '$timeout', 'lodash', 'cart', 'tools',
                function ($scope, $rootScope, drupal, $headermanager, $state, $filter, $window, $timeout, lodash, $cart, tools) {
                    $scope.loading = true;

                    $scope.title = $filter('translate')('shop.titlePage');

                    // build  breadcrumb
                    $scope.breadcrumb = [
                        { label: $filter('translate')('home'), state: 'homepage' },
                        { label: $filter('translate')('shop.titleShort') }
                    ];

                    // TODO: unmock theme
                    $headermanager.customize({
                        filled: true
                    });
                    var configWatcher = $rootScope.$watch('config.site.shop_banner', function (value) {
                        if (value) {
                            $headermanager.customize({
                                filled: true,
                                picture: { type: 'image', src: value.url }
                            });
                        }
                    });

                    var configSeoWatcher = $rootScope.$watch('config.site.shop_seo', function (config) {
                        if (config) {
                            if (config.keywords) {
                                tools.setMetaValue('keywords', config.keywords);
                            }
                            if (config.description) {
                                tools.setMetaValue('description', config.description);
                            }
                        }
                    });
                    $scope.$on('$destroy', function () {
                        configWatcher();
                        configSeoWatcher();
                    });

                    /*
                       Products management
                    */
                    drupal.getProducts().then(function (products) {
                        var categories = [
                            { title: $filter('translate')('shop.essentials'), essentials: true, products: [] }
                        ];

                        (products || []).forEach(function (product) {
                            var category = product.push ? categories[0] : lodash.find(categories, { title: product.family });
                            if (!category) {
                                category = {
                                    title: product.family,
                                    products: []
                                };
                                categories.push(category);
                            }
                            category.products.push(product);
                        });
                        $scope.categories = categories;
                        $scope.loading = false;
                    });
                }],
            templateUrl: 'src/views/shop/shop.html'
        })
        .state('shop.product', {
            url: '/{slug}--{id}',
            controller: ['$scope', '$rootScope', 'drupal', 'headermanager', '$filter', '$stateParams', '$state', '$window', 'lodash', 'tools', '$location', 'cart',
                function ($scope, $rootScope, drupal, $headermanager, $filter, $stateParams, $state, $window, lodash, tools, $location, $cart) {
                    $scope.loading = true;

                    $scope.tools = tools;

                    // expose site config
                    $scope.configSite = $rootScope.config.site;
                    $scope.pageUrl = $location.absUrl();

                    // build  breadcrumb
                    $scope.breadcrumb = [
                        { label: $filter('translate')('home'), state: 'homepage' },
                        { label: $filter('translate')('shop.titleShort'), state: 'shop.list' }
                    ];

                    // upsells : internships
                    $scope.upsellInternships = {
                        title: $filter('translate')('shop.upsellInternshipsTitle'),
                        field_internships: [],
                        field_link: {
                            title: $filter('translate')('shop.upsellInternshipsButton'),
                            uri: $state.href('internships')
                        }
                    };
                    // upsells management
                    $scope.productsPerLine = 1;
                    $scope.defaultProductsPerLine = 4;

                    // Mock for delivery tooltip
                    //  $scope.deliveryTooltip = $scope.configSite.tooltip_delivery.value;
                    /*
                        Product management
                    */

                    // print page
                    $scope.doPrint = function () {
                        window.print();
                    };

                    // check if product is in stock (with stock already in cart)
                    $scope.inStock = function (product) {
                        var myProduct = lodash.find($cart.products, {id: product.sfid});
                        return product.stock - (myProduct ? myProduct.field_quantity : 0) > 0;
                    };

                    $scope.$watch('product.variation', function(variation) {
                        if (variation) {
                            $scope.product.variations.forEach(function(item) {
                                if (item.value === variation) {
                                    $state.go('shop.product', {slug:$filter('slugify')(item.name), id:item.sfid});
                                }
                            });
                        }
                    });

                    drupal.getProduct($stateParams.id).then(function (product) {
                        if (!product) {
                            console.error('product not found with id', $stateParams.id);
                            $state.go('404');
                            return;
                        }
                        $scope.product = product;

                        // Matomo tracking
                        if (window._paq) {
                            try {
                                window._paq.push(['setEcommerceView',
                                    product.sfid,
                                    product.name,
                                    product.family
                                ]);
                                _paq.push(['trackPageView']);
                            } catch (e) { console.error(e); }
                        }

                        if(product.page && product.page.field_background_visual[0]){
                            $headermanager.customize({
                                picture: {type: 'image', src: product.page.field_background_visual[0].src, styles:product.page.field_background_visual[0] },
                                filled: true
                            });
                        }

                        if(product.previous){
                           drupal.getProduct(product.previous).then(function (prevProduct) {
                                if (prevProduct) {
                                   $scope.prevProduct = prevProduct;
                                }
                               else {
                                    console.log('previous product not found');
                                }
                           });
                        }
                        if(product.next){
                            drupal.getProduct(product.next).then(function (nextProduct) {
                                if (nextProduct) {
                                    $scope.nextProduct =  nextProduct;
                                }
                                else{
                                    console.log('next product not found');
                                }

                            });
                        }

                        $scope.slidesCount = ((product.page && product.page.field_visuals) || []).length;
                        // set titles & breadcrumb
                        $scope.title = product.family;
                        $scope.breadcrumb.push({ label: product.family });
                        // set upsells
                        return drupal.getProductRelated(product.sfid, 0);
                    }).then(function (relateds) {
                        $scope.upsellProducts = [];
                        $scope.upsellInternships.field_internships = [];
                        relateds.forEach(function (related) {
                            if (related.type === 'product') {
                                $scope.upsellProducts.push(related);
                            }
                            if (related.type === 'internship') {
                                $scope.upsellInternships.field_internships.push({ product: related });
                            }
                        });
                        // stop loading
                        $scope.loading = false;
                    });

                    /*
                       Slider management
                    */
                    $scope.slidesCount = 0;
                    $scope.sliderPosition = 0;
                    $scope.sliderSelected = 0;
                    $scope.sliderWidth = 0;
                    $scope.sliderStep = 4;

                    $scope.getSlideWidth = function () {
                        if ($scope.sliderWidth !== 0) {
                            return $scope.sliderWidth;
                        }
                        console.log('getSlideWidth');
                        var boundings = document.querySelector('.aqua-shop-product--slide-thumb').getBoundingClientRect();
                        var width = Math.round(boundings.width + 12); // 12 for the margin
                        console.log('found slide width of', width, 'px');
                        $scope.sliderWidth = width;
                        return width;
                    };
                    $scope.getSlidesRange = function () {
                        return [$scope.slidesCount];
                    };
                    var clearSliderWidth = function () {
                        console.log('clearSliderWidth');
                        $scope.sliderWidth = 0;
                    };
                    $scope.nextSlide = function () {
                        $scope.sliderPosition = Math.min($scope.sliderPosition + $scope.sliderStep, $scope.slidesCount - 1);
                    };
                    $scope.prevSlide = function () {
                        $scope.sliderPosition = Math.max($scope.sliderPosition - $scope.sliderStep, 0);
                    };
                    $scope.showSlide = function (position) {
                        $scope.sliderSelected = position;
                    };
                    $scope.toProduct = function (id, title) {
                        $state.go('shop.product', { id: id, slug: $filter('slugify')(title) });
                    };

                    $scope.addToCart = function (product) {
                        if (!product.pending) {
                            product.pending = true;
                            $cart.addProduct(product).then(function () {
                                product.pending = false;
                                // TODO : add error handler
                            });
                        }
                    };
                    // reestimate slider with when window is resized
                    $window.onresize = lodash.throttle(clearSliderWidth, 1000);
                }],
            templateUrl: 'src/views/shop/product.html'
        });
}]);
